import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { practicebmtransactionadd, BMProjectActions, BMProjectActionsHistory, filecontent, BMProjectApprovalHistroy, practiceBMGranttChart } from '../../../../models/slakpi';
import { division, user, department } from '../../../../models/admin';
import { UtilityService } from '../../../../services/utility.service';
import { BMApiService } from '../../../../services/bm.service';
import { UserService } from '../../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { Router, ActivatedRoute, Params } from '@angular/router';
declare var google: any;

import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { uniqBy } from 'lodash';
import { ToasterService } from '../../../../toaster.service';
import { Options } from '@angular-slider/ngx-slider';
import { formatDate } from '@angular/common';
@Component({
  selector: 'app-practice-bm-progress-approval',
  templateUrl: './practice-bm-progress-approval.component.html',
  styleUrls: ['./practice-bm-progress-approval.component.css']
})
export class PracticeBMProgressApprovalComponent implements OnInit {
  @ViewChild('progressStatusUpdateTemplate', { static: false }) progressStatusUpdateTemplate: TemplateRef<any>;
  @ViewChild('assignUserTemplate', { static: false }) assignUserTemplate: TemplateRef<any>;
  @ViewChild('attachmentTemplate', { static: false }) attachmentTemplate: TemplateRef<any>;
  public targetBandbtnElement: HTMLElement;
  public position_band: object = { X: 600, Y: 340 };
  //public shouldShowchart1 = false;
  //public shouldShowchart2 = false;
  showMyContainerarea: boolean = true;
  showMyContainerbar: boolean = true;
  gridOptions: GridOption;
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  angularGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  options: Options = {
    showTicksValues: true,
    floor: 0,
    ceil: 10,
    step: 1

  };
  enableUpdate: boolean = true;
  projectActionsHistoryDataSetFull: any[];
  itemuno: any;
  public objProjectActionHistory: BMProjectActionsHistory = new BMProjectActionsHistory();
  public objProjects: practicebmtransactionadd = new practicebmtransactionadd();
  public objProjectsActions: BMProjectActions = new BMProjectActions();
  progressTypeValue: any;
  projectID: any;
  data: any;
  dataset: any[];
  bmProgressMasterData: any[];
  loading: boolean;
  columnDefinitions: Column[];
  histroyColumnDefinitions: Column[];
  public uploadedFiles: Array<File> = [];
  statusDDList = [{ value: 1, text: 'Draft' }, { value: 2, text: 'Initiated' }, { value: 3, text: 'Execution' }, { value: 4, text: 'Hold' }, { value: 5, text: 'Completed' }]
  bmProgressItemUno: any;
  modalRef: BsModalRef;
  projectActionHistoryID: Object;
  projectActionsHistoryData: any;
  projectActionsHistoryDataSet: any[];
  attachementList: any[];
  actionType: any;
  columnDefinitionsType: Column[];
    projectActionsHistoryDataSetFull_DD: any;
    bmProgressUno: any;
    percentageInt: number;
    isUpdateProgress: { showTicksValues: true; floor: number; ceil: number; step: number; };
    isUpdateProgressShow: boolean;
    projectActionsHistoryValueDataSet: any[];
    bmprogressName: any;
    planActualPecetageTotal: any;
    collectActualPecetageTotal: any;
    analyseActualPecetageTotal: any;
    adaptActualPecetageTotal: any;
    login_UserID: any;
  userList: any;
  approveRejectComments: any;
    assignUserList: any;
    assignUser: string;
    progressItemList: any[];
    percentageTotal: any;
    approvalHistroyDataSet: any[];
    practiceBMGranttChartList: Object;
    user_data: Object;
    user_data_filter: any=[];
    firstApproverName: any;
    thirdApproverName: any;
    secondApproverName: any;
    firstApprvedDate: any;
    secondApprvedDate: any;
    thirdApprvedDate: any;
    firstApproverEnable: string;
    secondApproverEnable: string;
    thirdApproverEnable: string;
    approverEnableDisable: string;
    firstApprovedDate: any;
    secondApprovedDate: any;
    thirdApprovedDate: any;
    plannedEndDate: string;
    plannedStartDate: string;
    planTotalPercentage: any;
    collectTotalPercentage: any;
    adaptTotalPercentage: any;
    analyseTotalPercentage: any;
    tenantUno: any;
  constructor(public restApi: BMApiService, private modalService: BsModalService, private toaster: ToasterService, private _activatedRoute: ActivatedRoute, public router: Router, public utilityService: UtilityService, private userService: UserService, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    //this.modalRef.hide();
    //this.loading = true;
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 5
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 1,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this._activatedRoute
      .queryParams
      .subscribe(params => {
        let itemUno = params['itemUno'];
        if (itemUno != '' && itemUno != null && itemUno != undefined) {
          this.itemuno = itemUno;
          this.getBMProgressProjects(this.itemuno);
        
          this.loadPerformanceMaster(5);
          this.loadPerformanceApprovalHistroy();
          this.getUsers();
        }
        else {
          this.itemuno = '';
        }

      });
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
    this.tenantUno = this.userList.tenantUno;
    google.charts.load('current', { 'packages': ['corechart'] });
    google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart1);
    google.charts.setOnLoadCallback(this.practicebmprogresstransactionchart2);

  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  getUsers() {

    let inpValue = new user();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.user_data_filter = data;
       
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  getBMProgressProjects(id: any) {

    let inpValue = new practicebmtransactionadd();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = id;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getProjects(inpValue)
      .subscribe(data => {
       
        this.objProjects.projectName = data[0].projectName;
        this.objProjects.comments = data[0].comments;
        this.objProjects.peer = data[0].peer;
        this.objProjects.division = data[0].division;
        this.objProjects.projectManager = data[0].projectManager;
        this.plannedStartDate = formatDate(data[0].plannedStartDate, 'dd-MM-yyy', 'en-US');
        this.plannedEndDate = formatDate(data[0].plannedEndDate, 'dd-MM-yyy', 'en-US');
        this.objProjects.status = data[0].status;
        this.objProjects.firstAssingedApproversName = data[0].firstAssingedApproversName;
        this.objProjects.secondAssingedApproversName = data[0].secondAssingedApproversName;
        this.objProjects.thirdAssingedApproversName = data[0].thirdAssingedApproversName;
       

            },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  loadPerformanceMaster(value: any) {
    this.progressTypeValue = value;
    let valuePer: any = [];
    this.spinner.show();
    let inpValue = new BMProjectActions();
    inpValue.languageUno = 1033;
    inpValue.itemUno = (this.projectID != '' && this.projectID != null && this.projectID != undefined) ? this.projectID : this.itemuno;
    inpValue.condition = 3;
    inpValue.userUno = this.login_UserID;
    inpValue.tenantUno = this.tenantUno;

    this.restApi.getProjectActions(inpValue)
      .subscribe(data => {
        

        let filterDataSet = [];
        filterDataSet = uniqBy(data, 'id');
        this.progressItemList = filterDataSet;
       let planper = filterDataSet.filter(a => a.bmProgressItemUno == 5);
        this.planTotalPercentage = planper.reduce((a, b) => a + b.percentage, 0);
        let collectper = filterDataSet.filter(a => a.bmProgressItemUno == 6);
        this.collectTotalPercentage = collectper.reduce((a, b) => a + b.percentage, 0);
        let adaptper = filterDataSet.filter(a => a.bmProgressItemUno == 8);
        this.adaptTotalPercentage = adaptper.reduce((a, b) => a + b.percentage, 0);
        let analyzeper = filterDataSet.filter(a => a.bmProgressItemUno == 7);
        this.analyseTotalPercentage = analyzeper.reduce((a, b) => a + b.percentage, 0);


        this.data = filterDataSet.filter(a => a.bmProgressItemUno == value);
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].id,
            bmProgressName: this.data[i].bmProgressName,
            bmProgressItemUno: this.data[i].bmProgressItemUno,
            percentage: this.data[i].percentage + '%',
            assignedUser: this.data[i].assignedUser,
            progressStatus: this.data[i].progressStatus,
            assignedUserName: this.data[i].assinedUserName,
            startDate: this.data[i].startDate,
            endDate: this.data[i].endDate


          };


          valuePer.push(this.data[i].percentage)
        }

        this.percentageTotal = valuePer.reduce((a, b) => a + b, 0);

        //document.getElementById("planprogress").style.width = this.percentageTotal + "%";
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setGridBMProgressDefn();
        }
        else {
          this.setGridBMProgressDefn();
        }
        this.bmProgressMasterData = mockDataset;
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridBMProgressDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'bmProgressName', name: 'Task Name', field: 'bmProgressName', sortable: true, type: FieldType.string, filterable: false, width: 200,

      },
      {
        id: 'assignedUserName', name: 'Assigned User Name', field: 'assignedUserName', sortable: true, type: FieldType.string, filterable: false, width: 100,

      },
      {
        id: 'startDate', name: 'Start Date', field: 'startDate', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'endDate', name: 'End Date', field: 'endDate', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'bmProgressValue', name: 'Percentage', field: 'percentage', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },
      {
        id: 'progressStatus', name: 'Progress', field: 'progressStatus', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },

  

    ]


  }


  loadPerformanceApprovalHistroy() {
    
   
    this.spinner.show();
    let inpValue = new BMProjectApprovalHistroy();
    inpValue.id =this.itemuno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getProjectsApprovalHistroy(inpValue)
      .subscribe(data => {
        
        let dataList :any;
         dataList = data;
        let firstApproverList = dataList.filter(item => item.status == 'Approval 1');
        this.firstApproverName = (firstApproverList.length > 0) ? firstApproverList[0].firstApprovedName : '';
        this.firstApprovedDate = (firstApproverList.length > 0) ?firstApproverList[0].firstApprovedDate:'';
        let secondApproverList = dataList.filter(item => item.status == 'Approval 2');
        this.secondApproverName = (secondApproverList.length > 0) ? secondApproverList[0].secondApprovedName : '';
        this.secondApprovedDate = (secondApproverList.length > 0) ? secondApproverList[0].secondApprovedDate:'';
        let thirsApproverList = dataList.filter(item => item.status == 'Approval 2');
        this.thirdApproverName = (thirsApproverList.length > 0) ? thirsApproverList[0].thirdApprovedName : '';
        this.thirdApprovedDate = (thirsApproverList.length > 0) ? thirsApproverList[0].thirdApprovedDate:'';


        let filterDataSet: any;
        filterDataSet = uniqBy (data,'id');
      
       
        const mockDataset = [];
        for (let i = 0; i < filterDataSet.length; i++) {

          mockDataset[i] = {
            id: filterDataSet[i].id,
            projectUno: filterDataSet[i].projectUno,
            projectName: filterDataSet[i].projectName,
            approverName: filterDataSet[i].approverName,
            status: filterDataSet[i].status,
            comments: filterDataSet[i].comments,
            enteredBy: filterDataSet[i].enteredBy,
            enteredOn: filterDataSet[i].enteredOn,
            firstApprovedName: filterDataSet[i].firstApprovedName,
            secondApprovedName: filterDataSet[i].secondApprovedName,
            thirdApprovedName: filterDataSet[i].thirdApprovedName,
            firstApprovedDate: filterDataSet[i].firstApprovedDate,
            secondApprovedDate: filterDataSet[i].secondApprovedDate,
            thirdApprovedDate: filterDataSet[i].thirdApprovedDate,
          };
         
        
         
        }
       
        this.approvalHistroyDataSet = mockDataset;
       
       // this.firstApproverName = (filterDataSet[i].status == 'Approval 1') ? filterDataSet[i].firstApprovedName : '';
       
        if (mockDataset.length > 0) {
          this.setGridBMProgressApprovalHistroyDefn();
        }
        else {
          this.setGridBMProgressApprovalHistroyDefn();
        }
      
        this.loading = false;
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }



  setGridBMProgressApprovalHistroyDefn() {
    let temp = this;
    this.histroyColumnDefinitions = [

      {
        id: 'projectName', name: 'Project Name', field: 'projectName', sortable: true, type: FieldType.string, filterable: false, width: 200,

      },
      {
        id: 'approverName', name: 'Approver', field: 'approverName', sortable: true, type: FieldType.string, filterable: false, width: 100,

      },
      {
        id: 'status', name: 'Status', field: 'status', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'comments', name: 'Comments', field: 'comments', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'enteredBy', name: 'Action By', field: 'enteredBy', sortable: true, type: FieldType.string, filterable: false, width: 40,

      },
      {
        id: 'enteredOn', name: 'Action On', field: 'enteredOn', sortable: true, type: FieldType.string, filterable: false, width: 10,

      },



    ]


  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  checkNullOrEmpty(value: any) {
    if (value == null || value == '' || value == undefined) {
      return '0';
    }
    else {
      return value
    }
  }


  changeActionType(e) {
    this.actionType = (e.length == 0 || e[0].value == 'All') ? '' : e[0].value;
    if (this.actionType && this.actionType != '')
      this.projectActionsHistoryDataSet = this.projectActionsHistoryDataSetFull.filter(e => e.actionType == this.actionType)
    else
      this.projectActionsHistoryDataSet = this.projectActionsHistoryDataSetFull;

  }

  
  backtoInbox() {

  }

  practicebmprogresstransactionchart1 = () => {

    const data = google.visualization.arrayToDataTable([
      ['Year', 'Sales', 'Expenses'],
      ['2013', 1000, 400],
      ['2014', 1170, 460],
      ['2015', 660, 1120],
      ['2016', 1030, 540]
    ]);

    const options = {
      title: 'Company Performance',
      hAxis: { title: 'Year', titleTextStyle: { color: '#333' } },
      vAxis: { minValue: 0 }
    };


    const chart = new google.visualization.AreaChart(document.getElementById('practicebmprogresstransactionchart1'));
    chart.draw(data, options);
  }



  practicebmprogresstransactionchart2 = () => {

    const data = google.visualization.arrayToDataTable([
      ['Month', 'Bolivia', 'Ecuador', 'Madagascar', 'Papua New Guinea', 'Rwanda', 'Average'],
      ['2004/05', 165, 938, 522, 998, 450, 614.6],
      ['2005/06', 135, 1120, 599, 1268, 288, 682],
      ['2006/07', 157, 1167, 587, 807, 397, 623],
      ['2007/08', 139, 1110, 615, 968, 215, 609.4],
      ['2008/09', 136, 691, 629, 1026, 366, 569.6]
    ]);

    const options = {
      title: 'Monthly Coffee Production by Country',
      vAxis: { title: 'Cups' },
      hAxis: { title: 'Month' },
      seriesType: 'bars',
      series: { 5: { type: 'line' } }
    };



    const chart = new google.visualization.ComboChart(document.getElementById('practicebmprogresstransactionchart2'));
    chart.draw(data, options);
  }

  approveOrRejectComments(value: any) {
    if (this.approveRejectComments != null && this.approveRejectComments != undefined) {
      let obj = new BMProjectActions();
      obj.id = this.itemuno;

      obj.status = (value == 'Approved') ? this.objProjects.status:'Draft';
      obj.comments = (this.approveRejectComments != null && this.approveRejectComments != undefined) ? this.approveRejectComments : '';
      obj.userUno = this.login_UserID;
      obj.tenantUno = this.tenantUno;
      this.restApi.updateProjectApprovalOrReject(obj)
        .subscribe(data => {

          if (data != null && data != undefined && data != '' && data != 'failure') {
           
          
            if (value == 'Approved') {
              this.toaster.show('success', 'Success', 'Approved Succesfully.');
            }
            else {
              this.toaster.show('success', 'Success', 'Reject Succesfully.');
            }

            this.loadPerformanceApprovalHistroy();
            this.router.navigate(['/practice-bm-progress-approval-list']);
          }
          else {
            //Swal.fire('Error', 'Something went wrong', 'error');
            this.toaster.show('error', 'Error', 'Something went wrong');
            this.spinner.hide();

          }
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          //this.spinner.hide();
        });
      return true;
    }
    else {
      this.toaster.show('error', 'Error', 'Please enter the required information');
      return
    }
  }


}

